import BaseCore from 'cores/BaseCore'
import { createBrowserHistory } from 'history'
    
//Classes
    import DataStatus from './DataStatus'
    import Routing from './Routing'
    import Settings from './Settings'
    import Ui from './Ui'
    import User from './User'
    import LocalStore from './LocalStore'
    import Logger from './Logger'
    import Interfaces from "./Interfaces";
    import GoogleAnalytic from './GoogleAnalytic'

class AppCore extends BaseCore {
    initialState = {
        current_page: null,
        data_status: DataStatus.getInitialData([
            'settings',
            'user',
        ]),
        ui: {
            not_found: false,
            is_loading: true,
            open_region_select: false
        },
        test: 0
    }

    constructor() {
        super()

        this.history = createBrowserHistory()

        this.initializeStore()
    }

    SetPage( current_page ) {
        this.updateStore({
            current_page: {$set: current_page}
        })
    }

    async initialize() {
        this.Logger = new Logger(this)
        this.DataStatus = new DataStatus( this )
        this.Routing = new Routing( this )
        this.Settings = new Settings( this )
        this.Ui = new Ui( this )
        this.User = new User( this )
        this.LocalStore = new LocalStore( this )
        this.Interfaces = new Interfaces( this )
        this.GoogleAnalytic = new GoogleAnalytic(this)

        this.Ui.SetLoading( true, "AppCore::initialize" )

        await this.Settings.LoadGlobalSettings()
        
        /*For user:*/
            await this.User.AuthBySaveKey()

        this.Ui.SetLoading( false, "AppCore::initialize" )
    }
}

export default new AppCore()